import request from "@/CommonDP/utils/request";

export default {
  taskpackagetypedelete(packageId) {
    return request
      .get("/task-package-type/delete?packageId=" + packageId)
      .then(res => res);
  },

  taskpackagetypeinsert(data) {
    return request
      .post("/task-package-type/insert", data)
      .then(res => res);
  },

  pwdQueryList(id, pwd) {
    return request
      .get(`/halo/api/app-doc-center/v1/doc/link/share-pwd?id=${id}&pwd=${pwd}`)
      .then(res => res);
  },
  taskpackagetypelist(enterpriseId) {
    return request
      .get(`/task-package-type/list?enterpriseId=${enterpriseId}`)
      .then(res => res);
  },
  taskpackagetypeedit(data) {
    return request
      .post("/task-package-type/edit", data)
      .then(res => res);
  },
  // 计划字典
  taskpackagedictlist() {
    return request
      .get(`/task-package/dict-list`)
      .then(res => res);
  },
  // 计划字典 树状
  queryTaskTypeTree() {
    return request
      .get(`/task-package/dic/task/tree`)
      .then(res => res);
  },
  taskpackagelabellist() {
    return request
      .get(`/system-settings/enable-label`)
      .then(res => res);
  },
  taskpackagesavelabel(data) {
    return request
      .post("/task-package/save-label", data)
      .then(res => res);
  },
  // 可选择得计划列表
  taskpackagetasktreelist(packageId) {
    return request
      .get(
        `/task-package/task-tree-list?packageId=${packageId}`
      )
      .then(res => res);
  },
  taskpackageinsertplan(data) {
    return request
      .post("/task-package/insert-plan", data)
      .then(res => res);
  },
  taskpackagelist(data) {
    return request
      .post("/task-package/list", data)
      .then(res => res);
  },
  taskpackagedeleteplan(taskId) {
    return request
      .get(`/task-package/delete-plan?taskId=${taskId}`)
      .then(res => res);
  },
  taskpackagemove(taskId, moveType) {
    return request
      .get(
        `/task-package/move?taskId=${taskId}&moveType=${moveType}`
      )
      .then(res => res);
  },
  taskpackageupAndDown(taskId, moveType) {
    return request
      .get(
        `/task-package/upAndDown?taskId=${taskId}&moveType=${moveType}`
      )
      .then(res => res);
  },
  taskpackageplandetails(taskId) {
    return request
      .get(`/task-package/plan-details?taskId=${taskId}`)
      .then(res => res);
  },
  taskpackagerelationtaskList(taskId) {
    return request
      .get(`/task-package/relation-taskList?taskId=${taskId}`)
      .then(res => res);
  },
  taskpackageeditplan(data) {
    return request
      .post("/task-package/edit-plan", data)
      .then(res => res);
  },
  taskpackagelinktask(data) {
    return request
      .post("/task-package/link-task", data)
      .then(res => res);
  },
  prjplantaskimporttask(data) {
    return request
      .post("/prj-plan-task/import-task", data)
      .then(res => res);
  },

  queryLabelNew() {
    return request
      .get(`/task-package/enable-label/new`)
      .then(res => res);
  },
  querySpecRoleList(prjId) {
    return request
      .get(`/project/getSpecList?prjId=${prjId}`)
      .then(res => res);
  },
  taskPackageTypeMove(params) {
    return request.post("/task-package-type/move", params)
      .then(res => res);
  }
};
